module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "faq-page"
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "question"
  }, [_vm._v("\n      Почему названия статей и имена авторов отображаются в верхнем регистре? Можно ли это исправить?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "answer"
  }, [_vm._v("\n      К сожалению, именно в таком виде эти данные отдает E-library.\n      Мы никак не можем это исправить, т.к. автоматическое преобразование к правильному регистру невозможно. Если вам принципиален этот момент, вы можете исправить вручную, нажав кнопку «Дополнительно».\n    ")]), _vm._v(" "), _c('h4', {
    staticClass: "question"
  }, [_vm._v("\n      Я сформировал ссылки по ГОСТ, но у меня проблемы с правильной нумерацией ссылок. Может ли ваш проект в этом помочь?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "answer"
  }, [_vm._v("\n      В будущем мы планируем реализовать текстовый редактор, который будет автоматически нумеровать ссылки в правильном порядке. Вы можете ознакомиться "), _c('router-link', {
    attrs: {
      "to": {
        name: 'editor'
      }
    }
  }, [_vm._v("с пробной тестовой версией")]), _vm._v(" нашего редактора. Кроме того, если вы используете текстовые процессоры, такие как Microsoft Word или OpenOffice Writer, вы можете добавлять элементы литературы в качестве концевых сносок.\n    ")], 1), _vm._v(" "), _c('h4', {
    staticClass: "question"
  }, [_vm._v("\n      Я попробовал воспользоваться вашим редакторам, но там нет возможности вставки изображений, формул, таблиц и даже разделения статьи на разделы. Чем он тогда может мне помочь?\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "answer"
  }, [_vm._v("\n      С сожалению, на текущий момент эти функции действительно не реализованы. Вы можете использовать редактор для написания текстовой части статьи, затем экспортировать результат Word, после чего добавить требуемые элементы.\n    ")])]), _vm._v(" "), _c('footer-bar')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("\n        ArtJump — вопросы и ответы\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77a23e3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FaqPage.vue
// module id = 1015
// module chunks = 1